module.exports = __webpack_public_path__ + "static/media/brochure-thunderstruck-logo.e994ab12.webp";